<template>
  <div>
    <v-card :loading="loading" :disabled="loading">
      <v-card-title> {{ $t("registered_program_list.title") }}</v-card-title>
      <v-divider color="white"></v-divider>
      <v-card-text class="px-1 px-md-3 px-xl-6">
        <router-link to="/undergraduate/announcement" tag="div">
          <v-card>
            <v-card-text>
              <span
                class="red--text"
                v-html="$t('registered_program_list.announcement')"
              ></span>

              <v-btn
                rounded
                class="ml-3 red--text"
                to="/undergraduate/announcement"
              >
                CLICK
              </v-btn>
            </v-card-text>
          </v-card>
        </router-link>

        <div v-for="year in availble_year" :key="year.YEAR_ID">
          <v-card
            v-for="round in year.rounds"
            :key="round.ROUND_ID"
            color="white"
            elevation="5"
            class="mt-3"
          >
            <v-card-title>
              <span
                class="deep-purple--text font-weight-bold mr-2"
                style="font-size: 25px"
              >
                {{ objectTranslator(year, "LEVEL_NAME") }}
              </span>
              <span
                class="deep-orange--text font-weight-bold"
                style="font-size: 25px"
                >{{ $t("registered_program_list.academic_year") }} :
                {{ year.YEAR }}
              </span>
              <span
                class="font-weight-light ml-2 dark--text"
                style="font-size: 20px"
                >{{ $t("registered_program_list.round") }} :
                {{ round.ROUND_NUMBER }} -
                {{ objectTranslator(round, "ROUND_NAME") }}
              </span>
            </v-card-title>
            <v-card-text class="px-1 px-md-3 px-xl-6">
              <!-- ---------------------------------------------------------- -->
              <v-card
                v-for="project in projects_by_round(
                  available_registeredProject,
                  round.ROUND_ID
                )"
                :key="project.REGISTER_ID"
                class="mb-3"
              >
                <v-card-title class="indigo darken-3">
                  <span class="grey--text text--lighten-4 font-weight-light">
                    {{ $t("registered_program_list.project_application") }} :
                    {{ objectTranslator(project, "PROJECT_NAME") }}
                  </span>
                </v-card-title>
                <v-card-text class="grey darken-4">
                  <v-row>
                    <v-col cols="12" xl="6">
                      <div class="d-flex justify-space-between">
                        <span class="amber--text lighten-1">
                          {{ $t("registered_program_list.registration_no") }} :
                          {{ project.REGISTER_ID }}
                        </span>
                        <span>
                          <v-btn
                            v-if="
                              project.LEVEL_ID === '1' && timeline(2, project)
                            "
                            link
                            outlined
                            color="amber lighten-1"
                            :to="{
                              path:
                                'application_pdf_undergraduate' +
                                '/' +
                                project.REGISTER_ID,
                            }"
                            target="_blank"
                            >{{
                              $t("registered_program_list.application_document")
                            }}
                          </v-btn>
                          <v-btn
                            v-if="
                              (project.LEVEL_ID === '2' ||
                                project.LEVEL_ID === '3') &&
                              timeline(2, project)
                            "
                            link
                            color="amber lighten-1"
                            :to="{
                              path:
                                'application_pdf_graduate' +
                                '/' +
                                project.REGISTER_ID,
                            }"
                            target="_blank"
                            ><v-icon class="mr-1">mdi-note-text-outline</v-icon>
                            {{
                              $t("registered_program_list.application_document")
                            }}
                          </v-btn>
                          <v-btn
                            v-if="
                              project.LEVEL_ID === '2' ||
                              project.LEVEL_ID === '3'
                            "
                            link
                            outlined
                            color="blue lighten-1"
                            :to="{
                              path: 'graduate/announcement_file_download',
                            }"
                            class="ml-0 ml-sm-2 mt-2 mt-sm-0"
                            target="_blank"
                            ><v-icon class="mr-1"
                              >mdi-file-download-outline</v-icon
                            >
                            {{
                              $t("registered_program_list.additional_documents")
                            }}
                          </v-btn>
                        </span>
                      </div>
                      <div style="font-size: 15px; color: #2979ff">
                        <h5>
                          {{ $t("registered_program_list.open_date") }} :
                          {{
                            dateFromDBTranslator(project.START_APPLICATION_DATE)
                          }}
                          -
                          {{
                            dateFromDBTranslator(project.END_APPLICATION_DATE)
                          }}
                        </h5>
                      </div>
                      <div class="white--text pt-4 mb-2">
                        {{ $t("registered_program_list.curriculum_to_apply") }}
                      </div>
                      <div
                        v-for="(curr, index) in project.register_curriculum"
                        :key="curr.CURRICULUM_ID"
                        class="white--text ml-5 mb-3"
                      >
                        <v-icon class="red--text">mdi-menu-right</v-icon>
                        {{ $t("registered_program_list.no") }} {{ index + 1 }} :
                        <span class="deep-orange--text"
                          >{{ $t("registered_program_list.faculty") }} :
                          {{
                            objectTranslator(curr.detail, "FACULTY_NAME")
                          }}</span
                        >
                        {{ $t("registered_program_list.curriculum") }} :
                        {{
                          objectTranslator(curr.detail, "CURRICULUM_SHORT_NAME")
                        }}
                        <span
                          v-if="
                            curr.detail.BRANCH_ID &&
                            curr.detail.BRANCH_ID !== '0'
                          "
                          class="grey--text lighten-2"
                          >{{ $t("registered_program_list.branch") }} :
                          {{
                            objectTranslator(curr.detail, "BRANCH_NAME")
                          }}</span
                        >
                        <span
                          v-if="curr.detail.LEVEL_ID !== '1'"
                          class="grey--text lighten-2"
                        >
                          | {{ $t("program_list.study_plan") }} :
                          {{ objectTranslator(curr.detail, "STUDY_PLAN_NAME") }}
                          | {{ $t("program_list.study_classes") }} :
                          {{
                            objectTranslator(curr.detail, "STUDY_CLASSES_NAME")
                          }}
                          <span v-if="curr.detail.SPECIFIC_NATION_ID !== '0'">
                            | {{ $t("program_list.specific_nation") }} :
                            {{
                              objectTranslator(
                                curr.detail,
                                "SPECIFIC_NATION_NAME"
                              )
                            }}
                          </span>
                        </span>
                        <!-- <v-divider class="yellow darken-4"></v-divider> -->
                      </div>
                      <ProjectFileUpload
                        :project_item="project"
                        :fetch="fetchRegisteredCurriculum"
                        v-if="
                          project.APPLICANT_CAN_UPLOAD_DOCUMENT === '1' ||
                          project.ADDITIONAL_FILE === '1'
                        "
                      />
                      <div class="pt-2"></div>
                      <div
                        v-if="!has_chumporn(project.register_curriculum)"
                        class="grey--text lighten-2"
                      >
                        {{ $t("confirm_regis.remark") }}<br />
                        {{ $t("confirm_regis.remark_payment_kmitl") }}<br />
                      </div>
                      <div
                        v-if="has_chumporn(project.register_curriculum)"
                        class="grey--text lighten-2"
                      >
                        {{ $t("confirm_regis.remark") }}<br />
                        <span class="yellow--text"
                          >{{ $t("confirm_regis.remark_payment_ch_1") }}<br />
                          {{ $t("confirm_regis.remark_payment_ch_2") }}<br />
                          {{ $t("confirm_regis.remark_payment_ch_3") }}<br />
                        </span>
                      </div>
                    </v-col>
                    <v-col cols="12" xl="6">
                      <div class="pa-3">
                        <v-timeline align-top dense dark class="white--text">
                          <!-- -------------------- -->
                          <v-timeline-item
                            fill-dot
                            color="yellow darken-3"
                            icon="mdi-timer-sand"
                            v-if="timeline(1, project)"
                          >
                            <div class="pt-2">
                              {{
                                $t(
                                  "registered_program_list.not_completed_all_information"
                                )
                              }}
                            </div>
                            <v-btn
                              color="white"
                              class="ma-1"
                              outlined
                              link
                              :to="{ name: 'applicant_info_general' }"
                              v-if="
                                sidebar_status &&
                                sidebar_status.user_info &&
                                !sidebar_status.user_info.passed
                              "
                              >{{ $t("menu.applicant_info_general") }}</v-btn
                            >
                            <v-btn
                              color="white"
                              class="ma-1"
                              outlined
                              link
                              :to="{ name: 'applicant_info_school' }"
                              v-if="
                                sidebar_status &&
                                sidebar_status.educational_background_ungrad &&
                                sidebar_status.educational_background_ungrad
                                  .required &&
                                !sidebar_status.educational_background_ungrad
                                  .passed
                              "
                              >{{ $t("menu.applicant_info_school") }}</v-btn
                            >
                            <v-btn
                              color="
                            white"
                              class="ma-1"
                              outlined
                              link
                              :to="{ name: 'applicant_info_university' }"
                              v-if="
                                sidebar_status &&
                                sidebar_status.educational_background_grad &&
                                sidebar_status.educational_background_grad
                                  .required &&
                                !sidebar_status.educational_background_grad
                                  .passed
                              "
                              >{{ $t("menu.applicant_info_university") }}</v-btn
                            >
                            <v-btn
                              color="white"
                              class="ma-1"
                              outlined
                              link
                              :to="{ name: 'applicant_info_medicine' }"
                              v-if="
                                sidebar_status &&
                                sidebar_status.educational_background_medicine &&
                                sidebar_status.educational_background_medicine
                                  .required &&
                                !sidebar_status.educational_background_medicine
                                  .passed
                              "
                              >{{ $t("menu.applicant_info_medicine") }}</v-btn
                            >
                            <v-btn
                              color="white"
                              class="ma-1"
                              outlined
                              link
                              :to="{ name: 'applicant_info_eng_inter' }"
                              v-if="
                                sidebar_status &&
                                sidebar_status.educational_background_inter &&
                                sidebar_status.educational_background_inter
                                  .required &&
                                !sidebar_status.educational_background_inter
                                  .passed
                              "
                              >{{ $t("menu.applicant_info_eng_inter") }}</v-btn
                            >
                            <v-btn
                              color="white"
                              class="ma-1"
                              outlined
                              link
                              :to="{ name: 'applicant_info_constraints' }"
                              v-if="
                                sidebar_status &&
                                sidebar_status.constraint &&
                                !sidebar_status.constraint.passed
                              "
                              >{{
                                $t("menu.applicant_info_constraints")
                              }}</v-btn
                            >
                          </v-timeline-item>
                          <v-timeline-item
                            fill-dot
                            color="green darken-2"
                            icon="mdi-check"
                            v-if="timeline(2, project)"
                          >
                            <div class="pt-2">
                              {{
                                $t(
                                  "registered_program_list.completed_the_application"
                                )
                              }}
                            </div>
                          </v-timeline-item>
                          <!-- -------------------- -->
                          <v-timeline-item
                            fill-dot
                            color="yellow darken-3"
                            icon="mdi-timer-sand"
                            v-if="timeline(3, project)"
                          >
                            <div class="pt-2">
                              {{
                                $t(
                                  "registered_program_list.print_pay_in_process"
                                )
                              }}
                              <br />
                              *{{
                                $t(
                                  "registered_program_list.verify_within_3_days"
                                )
                              }}<br />
                              <div class="yellow--text">
                                {{
                                  $t(
                                    "registered_program_list.payment_can_be_made_since"
                                  )
                                }}
                                {{
                                  dateFromDBTranslator(
                                    project.START_APPLICATION_PAY_DATE
                                  )
                                }}
                                {{ $t("registered_program_list.to") }}
                                {{
                                  dateFromDBTranslator(
                                    project.END_APPLICATION_PAY_DATE
                                  )
                                }}
                              </div>
                              <v-btn
                                class="ma-2"
                                outlined
                                color="amber lighten-1"
                                x-small
                                link
                                :to="{
                                  path:
                                    'application_kbank_slip' +
                                    '/' +
                                    project.REGISTER_ID,
                                }"
                                target="_blank"
                                >{{
                                  $t(
                                    "registered_program_list.print_payin_slip_kbank"
                                  )
                                }}</v-btn
                              >
                              <br />
                            </div>
                          </v-timeline-item>
                          <v-timeline-item
                            fill-dot
                            color="green darken-2"
                            icon="mdi-check"
                            v-if="timeline(4, project)"
                          >
                            <div class="pt-2">
                              {{
                                $t("registered_program_list.application_paid")
                              }}
                            </div>
                          </v-timeline-item>
                          <v-timeline-item
                            fill-dot
                            color="red darken-2"
                            icon="mdi-close"
                            v-if="timeline(5, project)"
                          >
                            <div class="pt-2">
                              {{
                                $t(
                                  "registered_program_list.did_not_make_payment_in_time"
                                )
                              }}
                            </div>
                          </v-timeline-item>
                          <!-- -------------------- -->
                          <v-timeline-item
                            fill-dot
                            color="yellow darken-2"
                            icon="mdi-timer-sand"
                            v-if="timeline(6, project)"
                          >
                            <div class="pt-2">
                              {{
                                $t(
                                  "registered_program_list.announcement_selection_result"
                                )
                              }}
                              <br />
                              <span class="yellow--text">
                                {{
                                  $t("registered_program_list.result_announced")
                                }}
                                <router-link
                                  class="font-weight-bold"
                                  :to="{ name: 'undergraduate_announcement' }"
                                  v-if="project.LEVEL_ID === '1'"
                                  >{{
                                    $t(
                                      "registered_program_list.result_announced_1"
                                    )
                                  }}</router-link
                                ><router-link
                                  class="font-weight-bold"
                                  :to="{ name: 'graduate_announcement' }"
                                  v-if="
                                    project.LEVEL_ID === '2' ||
                                    project.LEVEL_ID === '3'
                                  "
                                  >{{
                                    $t(
                                      "registered_program_list.result_announced_2"
                                    )
                                  }}</router-link
                                >{{
                                  $t(
                                    "registered_program_list.according_announced"
                                  )
                                }}
                              </span>
                            </div>
                          </v-timeline-item>
                          <v-timeline-item
                            fill-dot
                            color="green darken-2"
                            icon="mdi-check"
                            v-if="timeline(7, project)"
                          >
                            <div class="pt-2">
                              {{
                                $t(
                                  "registered_program_list.announcement_selection_result"
                                )
                              }}
                              <br />
                              <span class="green--text"
                                >{{ $t("registered_program_list.pass") }}
                              </span>
                            </div>
                          </v-timeline-item>
                          <v-timeline-item
                            fill-dot
                            color="red darken-2"
                            icon="mdi-close"
                            v-if="timeline(8, project)"
                          >
                            <div class="pt-2">
                              {{
                                $t(
                                  "registered_program_list.announcement_selection_result"
                                )
                              }}
                              <br />
                              <span class="red--text">{{
                                $t("registered_program_list.not_pass")
                              }}</span>
                            </div>
                          </v-timeline-item>
                          <!-- -------------------- -->
                          <v-timeline-item
                            fill-dot
                            color="yellow darken-2"
                            icon="mdi-timer-sand"
                            v-if="timeline(9, project)"
                          >
                            <div class="pt-2">
                              {{
                                $t(
                                  "registered_program_list.announcement_CH_result"
                                )
                              }}
                              <br />
                              <span class="yellow--text">
                                {{
                                  $t(
                                    "registered_program_list.result_has_not_been_announced"
                                  )
                                }}
                              </span>
                            </div>
                          </v-timeline-item>
                          <v-timeline-item
                            fill-dot
                            color="green darken-2"
                            icon="mdi-check"
                            v-if="timeline(10, project)"
                          >
                            <div class="pt-2">
                              {{
                                $t(
                                  "registered_program_list.announcement_CH_result"
                                )
                              }}
                              <br />
                              <span class="green--text">{{
                                $t("registered_program_list.select")
                              }}</span>
                            </div>
                          </v-timeline-item>
                          <v-timeline-item
                            fill-dot
                            color="red darken-2"
                            icon="mdi-close"
                            v-if="timeline(11, project)"
                          >
                            <div class="pt-2">
                              {{
                                $t(
                                  "registered_program_list.announcement_CH_result"
                                )
                              }}
                              <br />
                              <span class="red--text">{{
                                $t("registered_program_list.not_select")
                              }}</span>
                            </div>
                          </v-timeline-item>
                          <!-- -------------------- -->
                          <v-timeline-item
                            fill-dot
                            color="yellow darken-3"
                            icon="mdi-timer-sand"
                            v-if="timeline(12, project)"
                          >
                            <div class="pt-2">
                              {{
                                $t(
                                  "registered_program_list.print_payment_slip_assertion_in_process_assertion"
                                )
                              }}
                              <br />
                              *{{
                                $t(
                                  "registered_program_list.verify_within_3_days"
                                )
                              }}
                              <br />
                              <div class="yellow--text">
                                {{
                                  $t(
                                    "registered_program_list.payment_can_be_made_since"
                                  )
                                }}
                                {{
                                  dateFromDBTranslator(
                                    project.START_CONFIRM_PAY_DATE
                                  )
                                }}
                                ถึง
                                {{
                                  dateFromDBTranslator(
                                    project.END_CONFIRM_PAY_DATE
                                  )
                                }}
                              </div>
                              <v-btn
                                class="ma-2"
                                outlined
                                color="amber lighten-1"
                                x-small
                                link
                                :to="{
                                  path:
                                    'assertion_kbank_slip' +
                                    '/' +
                                    project.REGISTER_ID,
                                }"
                                target="_blank"
                                >{{
                                  $t(
                                    "registered_program_list.print_payin_slip_kbank"
                                  )
                                }}</v-btn
                              >
                              <br />
                            </div>
                          </v-timeline-item>
                          <!-- -------------------- -->
                          <v-timeline-item
                            fill-dot
                            color="green darken-2"
                            icon="mdi-check"
                            v-if="timeline(13, project)"
                          >
                            <div class="pt-2">
                              {{
                                $t("registered_program_list.already_assertion")
                              }}
                            </div>
                          </v-timeline-item>
                          <v-timeline-item
                            fill-dot
                            color="red darken-2"
                            icon="mdi-close"
                            v-if="timeline(14, project)"
                          >
                            <div class="pt-2">
                              {{
                                $t(
                                  "registered_program_list.did_not_make_payment_in_time"
                                )
                              }}
                            </div>
                          </v-timeline-item>
                          <!-- -------------------- -->
                        </v-timeline>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions
                  class="grey darken-4"
                  v-if="project.REFUSED === '0'"
                >
                  <v-btn elevation="0" color="red" dark>
                    <v-icon>mdi-close-circle</v-icon>
                    <span
                      class="ml-2"
                      @click="openCancelRegisDialog(project)"
                      >{{
                        $t("registered_program_list.cancel_application")
                      }}</span
                    >
                  </v-btn>
                </v-card-actions>
              </v-card>
              <!-- ---------------------------------------------------------- -->

              <h3
                class="red--text mt-5 pt-5 ml-5"
                v-if="
                  projects_by_round(canceled_registeredProject, round.ROUND_ID)
                    .length != 0
                "
              >
                <v-icon class="red--text">mdi-trash-can</v-icon>
                {{ $t("registered_program_list.canceled_application_list") }}
              </h3>
              <v-card
                v-for="project in projects_by_round(
                  canceled_registeredProject,
                  round.ROUND_ID
                )"
                :key="project.REGISTER_ID"
                class="mb-3 ml-5"
              >
                <v-card-text class="grey darken-4">
                  <div class="red--text">
                    <v-icon class="red--text">mdi-menu-right</v-icon>
                    {{
                      $t("registered_program_list.canceled_project_application")
                    }}
                    : {{ objectTranslator(project, "PROJECT_NAME") }} |
                    {{ $t("registered_program_list.registration_no") }} :
                    {{ project.REGISTER_ID }}
                  </div>
                  <div
                    v-for="(curr, index) in project.register_curriculum"
                    :key="curr.CURRICULUM_ID"
                    class="white--text ml-5 mb-2"
                  >
                    {{ $t("registered_program_list.no") }} {{ index + 1 }} :
                    <span class="deep-orange--text"
                      >{{ $t("registered_program_list.faculty") }} :
                      {{ objectTranslator(curr.detail, "FACULTY_NAME") }}</span
                    >
                    {{ $t("registered_program_list.curriculum") }} :
                    {{ objectTranslator(curr.detail, "CURRICULUM_SHORT_NAME") }}
                    <span
                      v-if="
                        curr.detail.BRANCH_ID && curr.detail.BRANCH_ID !== '0'
                      "
                      class="grey--text lighten-2"
                      >{{ $t("registered_program_list.branch") }} :
                      {{ objectTranslator(curr.detail, "BRANCH_NAME") }}</span
                    >
                  </div>
                  <div class="grey--text lighten-2">
                    {{ $t("registered_program_list.canceled_from_date") }} :
                    {{
                      dateTimeFromDBTranslatorFull(project.REFUSED_TIMESTAMP)
                    }}
                  </div>
                  <div class="grey--text lighten-2">
                    {{ $t("registered_program_list.reason_for_cancellation") }}
                    :
                    {{ project.REFUSED_REMARK }}
                  </div>
                </v-card-text>
              </v-card>

              <!-- ---------------------------------------------------------- -->
            </v-card-text>
          </v-card>
        </div>
        <!-- <div class="red--text"> ยกเลิกการสมัครด้วยตัวผู้สมัครเอง</div> -->
      </v-card-text>
    </v-card>

    <v-dialog v-model="cancel_regis_dialog_open" eager max-width="1200px">
      <v-form ref="cancel_form" v-model="cancel_form_status">
        <v-card v-if="to_cancel_project_object">
          <v-card-title>
            <span class="red--text font-weight-bold"
              >{{ $t("registered_program_list.cancellation_application_no") }}
              {{ to_cancel_project_object.REGISTER_ID }}</span
            >
          </v-card-title>
          <v-card-text class="red pt-4 white--text">
            {{
              $t(
                "registered_program_list.cancel_this_application_if_you_have_paid_application_fee"
              )
            }}
            {{
              $t(
                "registered_program_list.system_not_refund_application_fee_students"
              )
            }}
            <br />
            {{
              $t(
                "registered_program_list.if_student_would_like_cancel_application"
              )
            }}
            {{
              $t(
                "registered_program_list.please_fill_reason_for_cancellation_box_below"
              )
            }}
            <br />
            <div class="yellow--text pt-4">
              {{ $t("registered_program_list.project_application") }}
              {{ objectTranslator(to_cancel_project_object, "PROJECT_NAME") }}
              {{ $t("registered_program_list.academic_year") }}
              {{ to_cancel_project_object.YEAR }} |
              {{ $t("registered_program_list.round") }} :
              {{ to_cancel_project_object.ROUND_NUMBER }}
            </div>
            <div class="white--text">
              {{ $t("registered_program_list.curriculum_to_apply") }}
            </div>
            <div
              v-for="(
                curr, index
              ) in to_cancel_project_object.register_curriculum"
              :key="curr.CURRICULUM_ID"
              class="white--text ml-5 mb-3"
            >
              {{ $t("registered_program_list.no") }} {{ index + 1 }} :
              <span class="white--text"
                >{{ $t("registered_program_list.faculty") }} :
                {{ objectTranslator(curr.detail, "FACULTY_NAME") }}</span
              >
              | {{ $t("registered_program_list.curriculum") }} :
              {{ objectTranslator(curr.detail, "CURRICULUM_SHORT_NAME") }}
              |
              <span
                v-if="curr.detail.BRANCH_ID && curr.detail.BRANCH_ID !== '0'"
                class="white--text"
                >{{ $t("registered_program_list.branch") }} :
                {{ objectTranslator(curr.detail, "BRANCH_NAME") }}</span
              >
              <span v-if="curr.detail.LEVEL_ID !== '1'" class="white--text">
                | {{ $t("program_list.study_plan") }} :
                {{ objectTranslator(curr.detail, "STUDY_PLAN_NAME") }}
                | {{ $t("program_list.study_classes") }} :
                {{ objectTranslator(curr.detail, "STUDY_CLASSES_NAME") }}
                <span v-if="curr.detail.SPECIFIC_NATION_ID !== '0'">
                  | {{ $t("program_list.specific_nation") }} :
                  {{ objectTranslator(curr.detail, "SPECIFIC_NATION_NAME") }}
                </span>
              </span>
              <v-divider class="yellow darken-4"></v-divider>
            </div>
            <div class="white pa-2">
              <v-textarea
                filled
                :label="$t('program_list.reason_to_cancel')"
                v-model="reason_to_cancel"
                outlined
                :rules="requiredRules"
              ></v-textarea>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn outlined color="red" @click="confirmCancel">
              <v-icon>mdi-trash-can</v-icon>
              {{ $t("registered_program_list.confirm_cancel_application") }}
            </v-btn>
            <v-btn
              outlined
              color="dark"
              @click="cancel_regis_dialog_open = false"
              >{{ $t("registered_program_list.close") }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import ApplicantInfoProvider from "@/services/applicant_info";
import GenericProvider from "@/services/generic.provider";
import {
  objectTranslator,
  dateFromDBTranslator,
  dateTimeFromDBTranslatorFull,
} from "@/helper/translator";
import { uniq_by_prop } from "@/helper/array";
import validator from "@/helper/validator";
import ProjectFileUpload from "@/components/registeredProjectList/projectFileUpload";

const applicantInfoService = new ApplicantInfoProvider();
const genericService = new GenericProvider();
export default {
  name: "RegisteredProgramList",
  components: {
    ProjectFileUpload,
  },
  data: () => ({
    level_id: null,
    registeredProject: null,
    cancel_regis_dialog_open: null,
    to_cancel_project_object: null,
    reason_to_cancel: "",
    cancel_form_status: null,
    loading: false,

    requiredRules: [validator.required, validator.minChar(10)],
  }),
  computed: {
    sidebar_status() {
      return this.$store.state.auth.sidebar_status;
    },
    available_registeredProject() {
      if (this.registeredProject)
        return this.registeredProject.filter((item) => item.REFUSED !== "3");
      return [];
    },
    canceled_registeredProject() {
      if (this.registeredProject)
        return this.registeredProject.filter((item) => item.REFUSED === "3");
      return [];
    },
    availble_year() {
      if (this.registeredProject) {
        const filteredProject = this.registeredProject.filter((item) =>
          this.isDataInCurrentLevel(item.LEVEL_ID)
        );
        const uniqueByYearId = uniq_by_prop("YEAR_ID");
        const uniqueByRoundId = uniq_by_prop("ROUND_ID");
        const years = uniqueByYearId(filteredProject);
        return years.map((year_item) => {
          const rounds = uniqueByRoundId(filteredProject);
          const rounds_detail = rounds
            .filter((item) => item.YEAR_ID === year_item.YEAR_ID)
            .map((item) => ({
              ROUND_ID: item.ROUND_ID,
              ROUND_NUMBER: item.ROUND_NUMBER,
              ROUND_NAME_EN: item.ROUND_NAME_EN,
              ROUND_NAME_TH: item.ROUND_NAME_TH,
            }));

          let LEVEL_NAME_EN = "";
          let LEVEL_NAME_TH = "";
          if (year_item.LEVEL_ID === "1") {
            LEVEL_NAME_EN = "Bachelor Degree";
            LEVEL_NAME_TH = "ปริญญาตรี";
          } else if (year_item.LEVEL_ID === "2") {
            LEVEL_NAME_EN = "Master Degree";
            LEVEL_NAME_TH = "ปริญญาโท";
          } else if (year_item.LEVEL_ID === "3") {
            LEVEL_NAME_EN = "Doctor Degree";
            LEVEL_NAME_TH = "ปริญญาเอก";
          }

          return {
            YEAR: year_item.YEAR,
            YEAR_ID: year_item.YEAR_ID,
            LEVEL_ID: year_item.LEVEL_ID,
            LEVEL_NAME_EN: LEVEL_NAME_EN,
            LEVEL_NAME_TH: LEVEL_NAME_TH,
            rounds: rounds_detail,
          };
        });
      } else return [];
    },
    admission_register_status() {
      return this.$store.state.ref.admissionRegisterStatus;
    },
  },
  methods: {
    objectTranslator,
    dateFromDBTranslator,
    dateTimeFromDBTranslatorFull,

    projects_by_round(projects, round_id) {
      return projects.filter(
        (item) => item.ROUND_ID === round_id && item.LEVEL_ID !== "-"
      );
    },

    has_chumporn(curriculums) {
      return curriculums.reduce((result, item) => {
        return (
          result || (item.detail && item.detail.MASTER_REG_FACULTY_ID === "20")
        );
      }, false);
    },

    openCancelRegisDialog(project_item) {
      this.reason_to_cancel = "";
      this.to_cancel_project_object = project_item;
      this.cancel_regis_dialog_open = true;
    },
    async confirmCancel() {
      this.$refs.cancel_form.validate();
      if (this.cancel_form_status) {
        this.loading = true;
        const uid = localStorage.getItem("uid");
        let response = await applicantInfoService
          .cancelRegis(
            this.to_cancel_project_object.REGISTER_ID,
            this.reason_to_cancel,
            uid
          )
          .catch((error) => {
            this.$toasted.error(JSON.stringify(error.response.data.message), {
              duration: 0,
            });
            this.loading = false;
          });
        if (response && response.status) {
          this.loading = false;
          this.cancel_regis_dialog_open = false;
          this.$toasted.success(this.$t("toasted.delete_successfully"), {
            duration: 0,
          });
          this.fetchRegisteredCurriculum();
        }
      }
    },
    isDataInCurrentLevel() {
      // if (this.level === LEVEL_UNDERGRAD_PROP_TEXT) {
      //   return level_id === "1";
      // } else {
      //   return level_id !== "1";
      // }
      return true;
    },
    async fetchRegisteredCurriculum() {
      this.loading = true;

      this.$store.dispatch("ref/getAdmissionRegisterStatus");
      const uid = localStorage.getItem("uid");
      let data = await applicantInfoService.getRegisProject(uid);
      for (let regis_project of data) {
        if (regis_project.register_curriculum) {
          for (let item of regis_project.register_curriculum) {
            const cur_detial = await genericService.getCurriculumById(
              item.ADMISSION_CURRICULUM_ID
            );
            if (cur_detial[0]) {
              item.detail = cur_detial[0];
              regis_project.START_APPLICATION_DATE =
                cur_detial[0].START_APPLICATION_DATE;
              regis_project.END_APPLICATION_DATE =
                cur_detial[0].END_APPLICATION_DATE;
              regis_project.START_APPLICATION_PAY_DATE =
                cur_detial[0].START_APPLICATION_PAY_DATE;
              regis_project.END_APPLICATION_PAY_DATE =
                cur_detial[0].END_APPLICATION_PAY_DATE;
              regis_project.START_CONFIRM_PAY_DATE =
                cur_detial[0].START_CONFIRM_PAY_DATE;
              regis_project.END_CONFIRM_PAY_DATE =
                cur_detial[0].END_CONFIRM_PAY_DATE;
              regis_project.APPLICANT_CAN_UPLOAD_DOCUMENT =
                cur_detial[0].APPLICANT_CAN_UPLOAD_DOCUMENT;
              regis_project.PROJECT_NAME_EN = cur_detial[0].PROJECT_NAME_EN;
              regis_project.PROJECT_NAME_TH = cur_detial[0].PROJECT_NAME_TH;
              regis_project.ROUND_ID = cur_detial[0].ROUND_ID;
              regis_project.ROUND_NUMBER = cur_detial[0].ROUND_NUMBER;
              regis_project.ROUND_NAME_EN = cur_detial[0].ROUND_NAME_EN;
              regis_project.ROUND_NAME_TH = cur_detial[0].ROUND_NAME_TH;
              regis_project.YEAR = cur_detial[0].YEAR;
              regis_project.YEAR_ID = cur_detial[0].YEAR_ID;
              regis_project.LEVEL_ID = cur_detial[0].LEVEL_ID;
            } else {
              regis_project.START_APPLICATION_DATE =
                "หลักสูตรที่สมัครได้ถูกปิดไปแล้ว";
              regis_project.END_APPLICATION_DATE = "-";
              regis_project.START_APPLICATION_PAY_DATE = "-";
              regis_project.END_APPLICATION_PAY_DATE = "-";
              regis_project.START_CONFIRM_PAY_DATE = "-";
              regis_project.END_CONFIRM_PAY_DATE = "-";
              regis_project.APPLICANT_CAN_UPLOAD_DOCUMENT = "-";
              regis_project.PROJECT_NAME_EN = "-";
              regis_project.PROJECT_NAME_TH = "-";
              regis_project.ROUND_ID = "-";
              regis_project.ROUND_NUMBER = "-";
              regis_project.ROUND_NAME_EN = "หลักสูตรที่สมัครได้ถูกปิดไปแล้ว";
              regis_project.ROUND_NAME_TH = "หลักสูตรที่สมัครได้ถูกปิดไปแล้ว";
              regis_project.YEAR = "-";
              regis_project.YEAR_ID = "-";
              regis_project.LEVEL_ID = "-";
            }
          }
        }
      }
      this.registeredProject = data;
      this.loading = false;
    },
    timeline(id, project_item) {
      //กรอกข้อมูลยังไม่ครบ
      if (id === 1 && parseInt(project_item.REGISTER_STATUS_ID) === 1)
        return true;
      //กรอกข้อมูลการสมัครครบแล้ว
      else if (id === 2 && parseInt(project_item.REGISTER_STATUS_ID) >= 2)
        return true;
      //พิมพ์ใบชำระเงินค่าสมัคร/อยู่ระหว่างการจ่าย
      else if (id === 3 && parseInt(project_item.REGISTER_STATUS_ID) === 2)
        return true;
      //จ่ายค่าสมัครแล้ว
      else if (id === 4 && parseInt(project_item.REGISTER_STATUS_ID) >= 3)
        return true;
      //ไม่ชำระเงินในเวลาที่กำหนด
      // TODO - 5
      //ผลคัดเลือกการสมัคร ยังไม่ประกาศผล
      else if (
        id === 6 &&
        parseInt(project_item.REGISTER_STATUS_ID) === 3 &&
        parseInt(project_item.REFUSED) === 0
      )
        return true;
      //ผลคัดเลือกการสมัคร ผ่าน
      else if (
        id === 7 &&
        ((parseInt(project_item.REGISTER_STATUS_ID) === 4 &&
          parseInt(project_item.REFUSED) === 0) ||
          parseInt(project_item.REGISTER_STATUS_ID) > 4)
      )
        return true;
      //ผลคัดเลือกการสมัคร ไม่ผ่าน
      else if (
        id === 8 &&
        parseInt(project_item.REGISTER_STATUS_ID) == 4 &&
        parseInt(project_item.REFUSED) === 1
      )
        return true;
      //ผลการ Clearing House ยังไม่ประกาศผล
      else if (
        id === 9 &&
        parseInt(project_item.REGISTER_STATUS_ID) === 4 &&
        parseInt(project_item.REFUSED) === 0
      )
        return true;
      //ผลการ Clearing House ผ่าน
      else if (
        id === 10 &&
        ((parseInt(project_item.REGISTER_STATUS_ID) === 5 &&
          parseInt(project_item.REFUSED) === 0) ||
          parseInt(project_item.REGISTER_STATUS_ID) > 5)
      )
        return true;
      //ผลการ Clearing House ไม่ผ่าน
      else if (
        id === 11 &&
        parseInt(project_item.REGISTER_STATUS_ID) == 5 &&
        parseInt(project_item.REFUSED) === 2
      )
        return true;
      //พิมพ์ใบชำระเงินค่ายืนยันสิทธิ์/อยู่ระหว่างการยืนยันสิทธิ์
      else if (
        id === 12 &&
        parseInt(project_item.REGISTER_STATUS_ID) === 5 &&
        parseInt(project_item.REFUSED) === 0
      )
        return true;
      //ยืนยันสิทธิ์แล้ว
      else if (
        id === 13 &&
        parseInt(project_item.REGISTER_STATUS_ID) === 6 &&
        parseInt(project_item.REFUSED) === 0
      )
        return true;
      //ไม่ชำระเงินในเวลาที่กำหนด
      // TODO - 14
      return false;
    },
  },
  mounted() {
    this.fetchRegisteredCurriculum();
  },
};
</script>
